"use client";

import { useSyncExternalStore } from "react";
import { getThemePreference, isThemePreference, setThemePreference, subscribeTheme } from "@/lib/theme";

export function ThemeSelect() {
  const preference = useSyncExternalStore(subscribeTheme, getThemePreference, () => "dark");
  return (
    <label className="inline-flex shrink-0 items-center gap-3">
      <span className="text-xs text-muted">Appearance</span>
      <select
        value={preference}
        onChange={(event) => {
          if (isThemePreference(event.target.value)) setThemePreference(event.target.value);
        }}
        className="min-h-11 w-[104px] cursor-pointer rounded-lg border border-line-strong bg-panel px-3 text-sm font-medium text-ink hover:bg-raised focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-violet"
      >
        <option value="system">System</option>
        <option value="dark">Dark</option>
        <option value="light">Light</option>
      </select>
    </label>
  );
}
